<template>
  <sweet-modal ref="edit-member" width="60vw" hide-close-button>
    <div class="ba-flex ba-ai-center ba-jc-sb ba-mg-b-1">
      <h5 class="ba-color-blue1">{{ $t("ct-member-edit") }}</h5>
      <button class='ba-btn ba-btn-close ba-sm ba-rounded' @click.prevent="close">
        <builderall-icon code='64f7' />
      </button>
    </div>
    <hr class='ba-hr-row'>
    <div class="ba-grid ba-mg-y-1 ba-gp-08" v-if="user">
      <div class="ba-card ba-no-shadow ba-w-100" style="background-color: #eff2f8;">
        <div class="ba-w-100 ba-flex ba-ai-center ba-jc-sb">
          <span class="ba-montserrat-600">{{ $t('ct-name') }}</span>
          <span class="ba-montserrat-600">{{ $t('ct-email') }}</span>
          <span class="ba-montserrat-600"></span>
        </div>
      </div>
      <div class="ba-card ba-w-100 ba-no-shadow ">
        <div class="ba-flex ba-ai-center ba-jc-sb ba-w-100 ba-h-100">
          <span class="ba-montserrat-600" style="width: 150px;">{{ user.name }}</span>
          <hr class="ba-hr-column" style="height: 30px;">
          <span class="ba-montserrat-600">{{ user.email }}</span>
          <hr class="ba-hr-column" style="height: 30px;">
          <button class='ba-btn ba-btn-normal ba-sm ba-rounded' @click="show_logs = true" v-if="!show_logs"
            ba-tooltip-position='top' :ba-tooltip-title="$t('ct-members-log-login')">
            <builderall-icon code='settings' />
          </button>
          <span v-else></span>
        </div>
      </div>
    </div>

    <hr class='ba-hr-row'>

    <div class="ba-grid ba-mg-y-1 ba-gp-08 ba-w-100">
      <div v-if="show_logs">
        <div class="form-group col-12">
          <div class="d-flex justify-content-between">
            <p class="subtitle mb-0">{{ $t("ct-members-log-login") }}</p>
          </div>
          <template v-if="user.access_token_expires_at.length">
            <div class="form-row card-fields card-permissions justify-content-between"
              v-for="(accessToken) in user.access_token_expires_at">
              <strong>{{ $t("ct-login-expires-at") }}</strong>
              <span>{{ getDateExpiress(accessToken.expires_at) }}</span>
            </div>
          </template>
          <div class="ba-w-100" v-else>
            <div class="ba-w-100 ba-flex ba-jc-center">
              <p>{{ $t("ct-login-log-is-empty") }}</p>
            </div>
            <div class="ba-w-100 ba-flex ba-jc-center">
              <a href="#" @click.prevent="show_logs = false"
                class="ba-montserrat-600 ba-color-blue1 ba-text-underline">{{
                  $t("ct-members-log-voltar") }}</a>
            </div>
          </div>
        </div>
      </div>

      <template v-else>
        <div class="form-row">
          <div class="form-group col-12" v-if="user.custom_fields_config">
            <span class="subtitle mb-2 d-inline-block">{{
              $t("ct-custom-fields")
            }}</span>
            <div class="row">
              <div class="col-4" v-for="(field, index) in user.custom_fields_config" :key="field.order">
                <div class="form-row card-label">
                  <span>{{ field.label }}</span>
                </div>
                <div class="form-row card-fields card-permissions">
                  <p v-if="
                    user.custom_fields[field.tag] &&
                    user.custom_fields[field.tag].length > 0">
                    <span v-if="
                      field.label === 'datetime' || field.label === 'date'
                    ">
                      {{ this.getDate(user.custom_fields[field.tag], field.label) }}
                    </span>
                    <span v-else-if="field.label === 'checkbox'">
                      {{ user.custom_fields[field.tag].toString() }}
                    </span>
                    <span v-else>{{ user.custom_fields[field.tag] }}</span>
                  </p>
                  <p v-else>-</p>
                </div>
              </div>
            </div>
          </div>
        </div>



       
          <div class="ba-grid ba-w-100" v-if="user.restrict_permissions_obj && restrictAreas.length > 0">
            <span class="ba-custom-label">{{ $t("ct-permissions") }}</span>
            <div class="ba-flex ba-ai-start ba-jc-sb" v-for="(restrict_permission, index) in user.restrict_permissions_obj" :key="index">
              <div class="form-check">
                <input type="checkbox" class="form-check-input" :value="restrict_permission.restrict_area.id"
                  :id="`user-${restrict_permission.restrict_area.id}`" v-model="user.restrict_permissions_list"
                  :disabled="restrict_permission.restrict_area.type_id === 1 ||
                    restrict_permission.restrict_area.type_id === 4 ||
                    restrict_permission.has_expires_at
                    " />
                <label :for="`user-${restrict_permission.restrict_area.id}`" class="form-check-label">
                  {{ restrict_permission.restrict_area.name }} ({{
                    $t(`ct-${restrict_permission.restrict_area.restrict_area_type.key}`)
                  }})
                </label>
              </div>

              <template v-if="restrict_permission.restrict_area.type_id === 3">
                <div class="ba-grid">
                  <div class="custom-control custom-switch form-group w-100">
                    <input type="checkbox" class="custom-control-input" @change="changeHasExpire(index)"
                      :id="`has-expire-date${index}`" :checked="restrict_permission.has_expires_at" />
                    <label class="custom-control-label" :for="`has-expire-date${index}`">{{
                      $t("ct-enable-date-expire") }}</label>
                  </div>
                  <div class="ba-grid" v-if="restrict_permission.has_expires_at">
                    <label for="permission-expire-date" class="ba-custom-label">{{ $t("ct-date-expire") }}</label>
                    <input class="ba-input ba-md" @change="changeExpireDate(index)" type="date" required
                      v-model="restrict_permission.expire" id="permission-expire-date" />
                  </div>
                </div>
              </template>
            </div>
          </div>
      </template>
    </div>

    <div class="ba-flex ba-ai-center ba-jc-fe ba-gp-1">
      <div class="ba-flex ba-gp-06 ba-ai-center">
        <button slot="button" class="ba-btn ba-md ba-light" @click.prevent="close">{{
          $t('ct-cancel') }}</button>
        <button slot="button" class="ba-btn ba-md ba-blue" @click.prevent="updateUser" v-if="!show_logs">{{
          $t('ct-save')
          }}</button>
        <button class="btn btn-primary float-left text-uppercase m-0" v-else @click.prevent="updatePassword()">
          {{ $t("ct-update-password") }}
        </button>
      </div>
    </div>
  </sweet-modal>
</template>

<script>
import { SweetModal } from "sweet-modal-vue";
import Errors from '../../../../js/base/Errors';
import { getDate as getFormatDate } from '../../../../js/base/Utils';
import { edit as editWebsiteUser } from '../../../../js/services/restrictArea/websiteUsers';
export default {
  name: 'EditMember.vue',
  components: {
    SweetModal
  },
  props: ['website_id', 'restrictAreas'],
  data() {
    return {
      errors: new Errors(),
      show_logs: false,
      user: {}
    };
  },

  methods: {
    setUser(user) {
      this.show_logs = false;
      this.user = Object.assign({}, this.user, user);
    },

    open() {
      this.$refs['edit-member'].open();
    },

    close() {
      this.$refs['edit-member'].close();
    },

    getDate(date, type = 'datetime') {
      return getFormatDate(date, type);
    },

    getDateExpiress(d) {
      var date = new Date(d);

      // Converte a data salva no banco em utc para a data do brownser
      var dataUniversal = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()));

      return getFormatDate(dataUniversal);
    },

    reloadUsers() {
      this.$emit('reloadUsers');
    },

    updatePassword() {
      this.$emit('editWebsiteUserPassword', this.user);
    },

    changeHasExpire(index) {
      let vm = this;
      let user = { ...user };
      let restrict_permissions = [...this.user.restrict_permissions_obj];
      restrict_permissions[index].updated = true;

      if (restrict_permissions[index].has_expires_at) {
        restrict_permissions[index].has_expires_at = false;
        restrict_permissions[index].expire = false;
      } else restrict_permissions[index].has_expires_at = true;

      vm.user = Object.assign({}, vm.user, user);
    },

    changeExpireDate(index) {
      let vm = this;
      let user = { ...user };
      let restrict_permissions = [...this.user.restrict_permissions_obj];

      var dateExpire = new Date(restrict_permissions[index].expire);
      var dateNow = new Date();

      dateExpire.setHours(0);
      dateExpire.setMinutes(0);
      dateExpire.setSeconds(0);
      dateExpire.setMilliseconds(0);

      dateNow.setHours(0);
      dateNow.setMinutes(0);
      dateNow.setSeconds(0);
      dateNow.setMilliseconds(0);

      restrict_permissions[index].has_expires_at = true;
      restrict_permissions[index].updated = true;

      if (dateNow <= dateExpire) {
        this.user.restrict_permissions_list.push(
          restrict_permissions[index].restrict_area_id
        );

        restrict_permissions[index].active = true;
      } else {
        this.user.restrict_permissions_list = this.user.restrict_permissions_list.filter(
          id => id !== restrict_permissions[index].restrict_area_id
        );

        restrict_permissions[index].active = false;
      }

      vm.user = Object.assign({}, vm.user, user);
    },

    updateUser() {
      this.$loading.show();

      this.user.restrict_permissions_list = this.user.restrict_permissions_list.filter(Boolean);

      editWebsiteUser({ ...this.user, time_zone: this.$getTimeZone() })
        .then(response => {
          if (response.data.success) {
            this.$snotify.success(this.$t('ct-success-true'), {
              position: 'centerTop'
            });

            this.reloadUsers();
            this.close();
          } else {
            if (response.data.validator) {
              this.errors.record({ restrictArea: response.data.errors });
            } else {
              this.$snotify.error(this.$t('ct-success-false'), {
                position: 'centerTop'
              });

              this.close();
            }
          }
        })
        .catch(error => {
          console.log('error', error);
        })
        .finally(() => this.$loading.hide());
    }
  }
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/dashboard/pages/MembersArea/EditMember.vue